import { greaterAreaCrudConfig } from '@/config/objects/greater-areas';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Greater Areas list page
 */
export function GreaterAreasPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Greater Areas', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView config={greaterAreaCrudConfig} baseUrl="/greater-areas" breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
